import { render, staticRenderFns } from "./ProjectFormNew.vue?vue&type=template&id=e2555d1a&"
import script from "./ProjectFormNew.vue?vue&type=script&lang=js&"
export * from "./ProjectFormNew.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFormNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports